import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import type { Bonus } from '../types/product';
type BonusBlockProps = {
  bonus: Bonus;
  reversed: boolean;
};
export function BonusBlock({
  bonus,
  reversed
}: BonusBlockProps) {
  return <article className="grid items-center gap-6 md:grid-cols-2 md:gap-12" data-id="element-19" data-mp="1tef5gwb9jrmb">
      <div className={`-mx-5 md:mx-0 ${reversed ? 'md:order-2' : ''}`} data-id="element-20" data-mp="1ogdnkepkpycf">
        <img src={bonus.image} alt={`Bonus #${bonus.number}: ${bonus.title}`} className="block h-auto w-full" loading="lazy" data-id="element-21" data-mp="2m3co50jdzqfl" />
      </div>

      <div data-id="element-22" data-mp="2c4df3guplss2">
        <div className="flex flex-wrap items-center gap-3" data-id="element-23" data-mp="2c43vcb09chut">
          <span className="inline-flex items-center gap-1.5 rounded-lg bg-gold px-3 py-1.5 font-display text-sm font-black uppercase text-navy-950" data-id="element-24" data-mp="2c6hrkn6oc03y">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-25" data-mp="10qjca1kwkhua" />
            Bonus #{bonus.number}
          </span>
          <span className="text-sm font-semibold text-muted" data-id="element-26" data-mp="wn3j5f81kzmc">
            Illustrative value <span className="text-pulse line-through" data-id="element-27" data-mp="23zko2z1q1frt">${bonus.value} USD</span>
          </span>
        </div>
        <h3 className="mt-4 font-display text-[28px] font-black uppercase leading-tight text-navy-900 sm:text-4xl" data-id="element-28" data-mp="28xw1fjr868es">
          {bonus.title}
        </h3>
        <p className="mt-3 text-lg font-bold leading-snug text-pulse-600" data-id="element-29" data-mp="1z0rbr9y67ut8">{bonus.headline}</p>
        <div className="mt-3 space-y-2 text-[16px] leading-relaxed text-muted" data-id="element-30" data-mp="1z2lzew0tu110">
          {bonus.intro.map(p => <p key={p} data-id="element-31" data-mp="1pzt84srn9pb6">{p}</p>)}
        </div>

        <h4 className="mt-6 text-xs font-extrabold uppercase tracking-wider text-navy-700" data-id="element-32" data-mp="1q1e0cbqhkw5v">You’ll receive</h4>
        <ul className="mt-3 grid gap-x-5 gap-y-2.5 sm:grid-cols-2" data-id="element-33" data-mp="1b93tfgez5s2k">
          {bonus.items.map(item => <li key={item} className="flex items-start gap-2 text-[15px] font-medium leading-snug text-ink" data-id="element-34" data-mp="1g7x5r5iizd15">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-heal" strokeWidth={3} aria-hidden="true" data-id="element-35" data-mp="179lhha54srbv" />
              {item}
            </li>)}
        </ul>

        <div className="mt-6 rounded-2xl bg-mist p-5" data-id="element-36" data-mp="39027haz0zqr3">
          <p className="text-xs font-extrabold uppercase tracking-wider text-navy-700" data-id="element-37" data-mp="347sj3zdk6yqx">Why it’s valuable</p>
          <p className="mt-1.5 text-[15px] font-semibold leading-relaxed text-ink" data-id="element-38" data-mp="2z9zgfgbgsmve">{bonus.why}</p>
        </div>
        {bonus.note && <p className="mt-3 text-xs text-muted" data-id="element-39" data-mp="2v9760jquwbxj">{bonus.note}</p>}

        <p className="mt-5 inline-flex items-center gap-2 rounded-full bg-heal-50 px-4 py-2 text-sm font-extrabold uppercase tracking-wide text-heal" data-id="element-40" data-mp="3rxvasedka2p0">
          <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-41" data-mp="3mwfroruy2699" />
          Included with your purchase
        </p>
      </div>
    </article>;
}